import { useTranslation } from 'react-i18next'

interface SolicitudActivaModalProps {
  mensaje: string
  onClose: () => void
}

export function SolicitudActivaModal({ mensaje, onClose }: SolicitudActivaModalProps) {
  const { t } = useTranslation('simulador')

  return (
    <div
      className="fixed inset-0 z-[9998] flex items-center justify-center p-6"
      role="dialog"
      aria-modal="true"
      aria-labelledby="solicitud-activa-title"
    >
      <div
        className="absolute inset-0 bg-black/35"
        onClick={onClose}
      />
      <div className="relative z-[1] flex w-[min(100%,28rem)] flex-col items-center gap-3 rounded-sm bg-[#eef7fc] px-8 py-10 text-center shadow-[0_1.5rem_3rem_rgba(13,26,48,0.18)]">

        <div className="h-8 w-8 text-[#ffdb43]">
          <svg
            viewBox="0 0 24 24"
            fill="none"
            aria-hidden="true"
            className="h-full w-full"
          >
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" fill="currentColor" />
            <path d="M10.29 3.86L1.82 18a2 2 0 0 0 1.71 3h16.94a2 2 0 0 0 1.71-3L13.71 3.86a2 2 0 0 0-3.42 0z" stroke="currentColor" strokeWidth="1.5" strokeLinejoin="round" />
            <line x1="12" y1="9" x2="12" y2="13" stroke="#000" strokeWidth="1" strokeLinecap="round" />
            <circle cx="12" cy="17" r="0.5" fill="#000" stroke="#000" strokeWidth="0.75" />
          </svg>
        </div>

        <h2
          id="solicitud-activa-title"
          className="m-0 mt-1 text-[1.75rem] font-normal text-[#1c3042]"
        >
          {t('solicitudActivaTitulo')}
        </h2>
        <p className="m-0 mt-3 text-[1.0625rem] leading-normal text-[#535353]">
          {mensaje}
        </p>

        <button
          type="button"
          className="mt-3 w-auto cursor-pointer rounded border-none bg-[#ffdb43] px-32 py-3 text-[1rem] font-semibold text-[#20364d] [transition:opacity_0.15s_ease] hover:opacity-[0.88]"
          onClick={onClose}
        >
          {t('successAccept')}
        </button>

      </div>
    </div>
  )
}
